import { FormStore } from '@roc/feature-app-core';
import { amortizationOptions } from '@roc/feature-loans';
import { PPP_5_4_3_2_1, prePaymentPenaltyOptionsSingleProperty } from '@roc/feature-utils';

const maxLTV = 80;
const form = {
  fields: {
    loanToValue: {
      value: maxLTV,
      error: null,
      rule: '',
    },
    selectedLoanToValue: {
      value: maxLTV,
      error: null,
      rule: '',
    },
    amortization: {
      value: amortizationOptions[0]?.value,
      error: null,
      rule: 'required',
    },
    prepenaltyPayment: {
      value: PPP_5_4_3_2_1,
      error: null,
      rule: 'required',
    },
    rateType: {
      value: '30 Yr FRM',
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class LoanEconomicsFormStore extends FormStore {
  constructor(globalStore) {
    super(form, globalStore);
  }

  loadFloorRate(floorRate: number) {
    if (this.form.fields.interestRate.value < floorRate) {
      this.onFieldChange('interestRate', floorRate);
    }
  }

  loadPoints(floorPoints: number, maxPoints: number) {
    if (this.form.fields.totalPoints.value < floorPoints) {
      this.onFieldChange('totalPoints', floorPoints);
    }
    if (this.form.fields.totalPoints.value > maxPoints) {
      this.onFieldChange('totalPoints', maxPoints);
    }
  }
}
